import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');


var serviceName = "index";
var urunOrtopediService = {

    urunOrtopediTanimlama(urunKodu, referansNo, barkodNo, urunAdi, sutKodu) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                urunKodu: urunKodu,
                referansNo: referansNo,
                barkodNo :barkodNo,
                urunAdi :urunAdi,
                sutKodu: sutKodu,
                serviceName: "urunOrtopedi",
                methodName: "urunOrtopediTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    urunOrtopediListesi(durum,baslangic,limit) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                serviceName: "urunOrtopedi",
                methodName: "urunOrtopediListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    urunKoduArama(key,durum) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                key:key,
                durum:durum,
                serviceName: "urunOrtopedi",
                methodName: "urunKoduArama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunOrtopediCount(durum) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                durum: durum,
                serviceName: "urunOrtopedi",
                methodName: "urunOrtopediCount"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunOrtopediDetay(oUrunId) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                oUrunId : oUrunId,
                serviceName: "urunOrtopedi",
                methodName: "urunOrtopediDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunOrtopediDurumGuncelle(oUrunId,durum) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                oUrunId : oUrunId,
                durum : durum,
                serviceName: "urunOrtopedi",
                methodName: "urunOrtopediDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunOrtopediGuncelleme(oUrunId,referansNo,barkodNo,urunAdi,sutKodu) {
        var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
        var param = {
            data: {
                yonetimId: userData3H["yonetimId"],
                userToken: userData3H["token"],
                firmaKodu: userData3H["firmaKodu"],
                oUrunId: oUrunId,
                referansNo: referansNo,
                barkodNo: barkodNo,
                urunAdi: urunAdi,
                sutKodu: sutKodu,
                serviceName: "urunOrtopedi",
                methodName: "urunOrtopediGuncelleme"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },


}

export default urunOrtopediService

